import React from "react";
import { pdf } from "@react-pdf/renderer";
import { saveAs } from "file-saver";
import { registerKokilaFont } from "./registerKokilaFont";
import { GunaListPdfDocument } from "../Pages/Reports/ReportDocuments/GunaListPdfDocument";

export async function downloadGunaListPdf({
  headerText,
  reportTitle,
  dateRangeText,
  headers,
  accusedGroups,
  fileName,
  footerText,
}) {
  if (!accusedGroups?.length) {
    throw new Error("No data available for PDF export");
  }

  await registerKokilaFont();

  const blob = await pdf(
    <GunaListPdfDocument
      headerText={headerText}
      reportTitle={reportTitle}
      dateRangeText={dateRangeText}
      headers={headers}
      accusedGroups={accusedGroups}
      footerText={footerText}
    />
  ).toBlob();

  const resolvedName = fileName.endsWith(".pdf") ? fileName : `${fileName}.pdf`;
  saveAs(blob, resolvedName);
  return blob;
}
